import { Outlet } from 'react-router-dom';

// Decorative flourish SVG
const Flourish = () => (
  <svg className="w-32 h-8 text-stone-300" viewBox="0 0 120 24" fill="none">
    <path
      d="M0 12h40c8 0 12-6 20-6s12 6 20 6h40"
      stroke="currentColor"
      strokeWidth="0.75"
    />
    <circle cx="60" cy="12" r="2.5" fill="currentColor" />
    <circle cx="45" cy="12" r="1.5" fill="currentColor" opacity="0.5" />
    <circle cx="75" cy="12" r="1.5" fill="currentColor" opacity="0.5" />
  </svg>
);

export function AuthLayout() {
  return (
    <div className="min-h-screen flex relative overflow-hidden">
      {/* Left side - Decorative Panel */}
      <div className="hidden lg:flex lg:w-1/2 relative bg-gradient-to-br from-[#FAF8F5] via-[#F5EDE4] to-[#EDE4D8]">
        {/* Subtle pattern overlay */}
        <div
          className="absolute inset-0 opacity-40"
          style={{
            backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'60\' height=\'60\' viewBox=\'0 0 60 60\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M30 0L30 60M0 30L60 30\' stroke=\'%23C9A86C\' stroke-width=\'0.5\' fill=\'none\' opacity=\'0.15\'/%3E%3C/svg%3E")',
          }}
        />

        {/* Decorative circles */}
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute -top-1/4 -left-1/4 w-[60%] h-[80%] rounded-full bg-[#C9A86C]/10 blur-3xl" />
          <div className="absolute -bottom-1/4 -right-1/4 w-[50%] h-[70%] rounded-full bg-[#8B7355]/10 blur-3xl" />
        </div>

        {/* Content */}
        <div className="relative z-10 flex flex-col items-center justify-center w-full px-12">
          <div className="max-w-md text-center">
            {/* Decorative element */}
            <div className="mb-8">
              <svg className="w-16 h-16 mx-auto text-[#C9A86C]/60" viewBox="0 0 100 100" fill="none">
                <circle cx="50" cy="50" r="45" stroke="currentColor" strokeWidth="0.5" />
                <circle cx="50" cy="50" r="35" stroke="currentColor" strokeWidth="0.5" />
                <path d="M50 20 L50 80 M20 50 L80 50" stroke="currentColor" strokeWidth="0.5" />
                <circle cx="50" cy="50" r="8" fill="currentColor" opacity="0.3" />
              </svg>
            </div>

            <Flourish />

            <h1 className="font-serif text-4xl text-stone-800 mt-8 mb-4 tracking-tight">
              Creează momente
              <br />
              <span className="text-[#8B7355]">de neuitat</span>
            </h1>

            <p className="text-stone-500 leading-relaxed mb-8">
              Invitații digitale elegante pentru cele mai importante
              evenimente din viața ta. Nuntă, botez, aniversare -
              fiecare moment merită o invitație pe măsură.
            </p>

            <Flourish />

            {/* Feature highlights */}
          </div>
        </div>

        {/* Bottom decorative border */}
        <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#C9A86C]/30 to-transparent" />
      </div>

      {/* Right side - Auth Form */}
      <div className="flex-1 flex flex-col items-center justify-center p-6 lg:p-12 bg-white relative">
        {/* Subtle background texture */}
        <div
          className="absolute inset-0 opacity-[0.02]"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%' height='100%' filter='url(%23noise)'/%3E%3C/svg%3E")`,
          }}
        />

        {/* Mobile-only decorative top */}
        <div className="lg:hidden absolute top-0 left-0 right-0 h-32 bg-gradient-to-b from-[#FAF8F5] to-transparent" />

        <div className="w-full max-w-md relative z-10 animate-fade-in">
          <Outlet />
        </div>

        <p className="mt-8 text-xs text-stone-400 tracking-wide relative z-10">
          &copy; {new Date().getFullYear()} Invitații Online. Toate drepturile rezervate.
        </p>
      </div>
    </div>
  );
}
